import React from 'react';
import { useFeatureToggle } from '~/platform/utilities/feature-toggles';
import BasicLink from '../web-component-wrappers/BasicLink';

export default function ClaimLetterSection() {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const iscstIncludeDdlBoaLettersEnabled = useToggleValue(
    TOGGLE_NAMES.cstIncludeDdlBoaLetters,
  );
  const claimLetterLinkText = iscstIncludeDdlBoaLettersEnabled
    ? 'Get your VA claim letters'
    : 'Download your VA claim letters';
  const claimLetterSubText = iscstIncludeDdlBoaLettersEnabled
    ? 'You can download letters related to your claims. This includes decision letters and evidence requests.'
    : 'You can download your decision letters online. You can also get other letters related to your claims.';

  return (
    <div className="claim-letter-section vads-u-margin-top--4 vads-u-margin-bottom--4">
      <h2 id="your-claim-letters">Your claim letters</h2>
      <BasicLink
        active
        disable-analytics
        path="/track-claims/your-claim-letters"
        text={claimLetterLinkText}
      />
      <p className="vads-u-margin-y--0p5">{claimLetterSubText}</p>
    </div>
  );
}
